import { useOnnxModel } from "./useOnnxModel"

export const MODEL_URL = "https://public.instacover.ai/models/model-7618e3d3bf2c48ac8245c85e3f249887.onnx"

type UseCarViewModelQueryParams = {
  enabled: boolean
  organizationModelUrl?: string
}

export function useCarViewModelQuery(params: UseCarViewModelQueryParams) {
  const { enabled, organizationModelUrl } = params

  return useOnnxModel({
    modelUrl: organizationModelUrl ?? MODEL_URL,
    enabled,
  })
}
